import React from 'react'

const icon = require('../assets/images/lotus.svg')

const Icon = () => <img className="mb-4" src={icon} alt="" width="72" height="72" />

export default Icon



// WEBPACK FOOTER //
// ./src/components/Icon.js